export const ADMIN_DOCUMENT_ASSEMBLY = "core.admin.documents";
export const CONTENT_BLOCKS_READ = "core.documents.content-blocks.read";
export const CONTENT_BLOCKS_CREATE = "core.documents.content-blocks.create"
export const CONTENT_BLOCKS_PUBLISH = "core.documents.content-blocks.publish";

export default {
    ADMIN_DOCUMENT_ASSEMBLY,
    CONTENT_BLOCKS_READ,
    CONTENT_BLOCKS_CREATE,
    CONTENT_BLOCKS_PUBLISH
}